import "./AttributeWindow.css"
import React from "react"
import { inject, observer } from "mobx-react"

import Window from "./Window"
import RadarChart from "./RadarChart"

const AttributeTitle = inject(["app"])(
  observer(({ app }) => {
    return (
      <h1>
        Pers0nal1ty Chart
        {app.profiles.length ? (
          <span className="mbti">
            : {app.profiles.map(p => p.mbti.toUpperCase()).join(",")}
          </span>
        ) : null}
      </h1>
    )
  })
)

const AttributeWindow = ({ app }) => {
  // TODO: make size proportional to window?
  // 375px x 667px is iPhone 6

  const width = app.fitSize(650, 0.9, 375) // 700 or 90%
  const height = width - width * 0.1
  const title = <AttributeTitle />

  return (
    <Window
      className="AttributeWindow"
      title={title}
      width={width}
      height={height}
    >
      <RadarChart
        chartData={app.chartData}
        options={{ w: width - 20, h: height - 20 }}
      />
    </Window>
  )
}

export default inject(["app"])(observer(AttributeWindow))



// WEBPACK FOOTER //
// ./src/components/AttributeWindow.js